







































import { PropType, defineComponent } from '@vue/composition-api';
import { Issue } from '../../dataType';
import { useIssue } from '../../hooks/useIssue';

export default defineComponent({
  props: {
    issue: {
      type: Object as PropType<Issue>,
      required: true
    }
  },
  setup(props) {
    const { openIssue } = useIssue();
    return {
      toIssue: () => {
        openIssue(props.issue);
      }
    };
  }
});
